// extracted by mini-css-extract-plugin
module.exports = {"myTabs":"tag-generator_myTabs__rEUT5"};